<template>
    <base-notification :notification="notification" :highlight="highlight" :can-read="false">
        <p v-html="notification.data.message"></p>
        <time :datetime="notification.created_at" v-if="showDate">{{ notification.created_at }}</time>
        <button v-if="! notification.read_at" class="btn btn--sm btn--primary" @click="claim">Claim</button>

        <modal show="false" ref="achievementModal">

            <template v-slot:body>
                <div class="btn btn--white btn--wrapper text--center mb--md">
                    <img v-show="status === 'success'" src="/img/icons/success.svg" alt="Done" />
                    <img v-show="status === 'error'" src="/img/icons/error.svg" alt="Error" />
                </div>

                <h4 class="modal__title">
                    <span v-show="status === 'success'">Done</span>
                    <span v-show="status === 'error'">Error</span>
                </h4>

                <div class="mb--30">
                    <div class="loader mx--auto mb--20" v-if="showLoader"></div>
                    <div v-else-if="status === 'error'">
                        Something went wrong!
                    </div>
                    <div v-else>
                        Congratulations, your reward:
                        <div>
                            <ul>
                                <li v-for="reward in rewards">{{ reward }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:buttons><span></span></template>
        </modal>
    </base-notification>
</template>

<script>
    import BaseNotification from "./BaseNotification";

    export default {
        components: {BaseNotification},
        props: {
            notification: Object,
            showLink: {
                default: true
            },
            showDate: {
                default: true
            },
            highlight: {
                default: true
            }
        },

        data() {
            return {
                showLoader: false,
                rewards: [],
                status: null,
            }
        },

        methods: {
            claim() {
                this.showLoader = true
                this.$refs.achievementModal.open()

                axios.post('/web-api/achievements/claim', {
                    id: this.notification.data.achievementId
                }).then((response) => {
                    this.status = 'success'
                    this.rewards = response.data.rewards
                    this.markAsRead()
                    this.showLoader = false
                    this.$store.dispatch('auth/refreshVirtualBalance')
                }).catch((error) => {
                    if (error.response.status === 422) {
                        this.markAsRead()
                    }
                    
                    this.showLoader = false
                    this.status = 'error'
                })
            },

            markAsRead() {
                if (this.notification.read_at) {
                    return
                }

                axios.post('/notifications/mark-as-read', {
                    id: this.notification.id
                }).then(() => Quiz.$emit('notification-read', this.notification));
            }
        }
    }
</script>
